import './LoadingSpinner.css';

const LoadingSpinner = () => (
    <div className="loading__container">
        <img src="/icons/loading.svg" alt="loading"/>
    </div>
)

export default LoadingSpinner;
